// S-02 search params (Frontend §7.1): `q`, `status` (all | healthy | attention | inactive), `page`.
import type { ListClinicsParams } from '@pa/api/admin'
import { z } from 'zod'

export const CLINIC_STATUS_FILTERS = ['all', 'healthy', 'attention', 'inactive'] as const

export const clinicsSearchSchema = z.object({
  q: z.string().max(100).optional().catch(undefined),
  status: z.enum(CLINIC_STATUS_FILTERS).optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
})

export type ClinicsSearch = z.infer<typeof clinicsSearchSchema>

/** The `/v1/admin/clinics` query for a search (`attention` → `needs_attention`). */
export function listParams(search: ClinicsSearch): ListClinicsParams {
  const params: ListClinicsParams = {}
  if (search.q) params.q = search.q
  if (search.status && search.status !== 'all') {
    params.status = search.status === 'attention' ? 'needs_attention' : search.status
  }
  if (search.page && search.page > 1) params.page = String(search.page)
  return params
}
